import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { inboxTrx } from 'src/app/router-translation.labels';
import { CloseDialogButtonComponent } from 'src/app/components/dialog/close-dialog-button/close-dialog-button.component';

export interface CashbackTeaserToastData {
  title: string;
  body: string;
  icon?: string;
  ctaText?: string;
}

@Component({
  selector: 'app-cashback-teaser-toast',
  standalone: true,
  imports: [CommonModule, CloseDialogButtonComponent],
  templateUrl: './cashback-teaser-toast.component.html',
  styleUrls: ['./cashback-teaser-toast.component.scss']
})
export class CashbackTeaserToastComponent {
  readonly title: string;
  readonly body: string;
  readonly icon?: string;
  readonly ctaText: string;
  iconError = false;

  constructor(
    @Inject(MAT_SNACK_BAR_DATA) data: CashbackTeaserToastData,
    private snackBarRef: MatSnackBarRef<CashbackTeaserToastComponent>,
    private router: Router,
  ) {
    this.title = data.title;
    this.body = data.body;
    this.icon = data.icon;
    this.ctaText = data.ctaText || $localize`:@@cashback-acq-teaser-cta:More info`;
  }

  moreInfo(): void {
    this.router.navigate(['', inboxTrx]);
    this.snackBarRef.dismiss();
  }

  close(): void {
    this.snackBarRef.dismiss();
  }
}
